import L from 'leaflet'

const OUTDATED_LAT_OFFSET = 0.01
const OUTDATED_LNG_OFFSET = -0.5

/**
 * Convert server point coordinate to L.LatLng
 * @param serverCoordinate
 * @param outdated - if true coordinate were create in OL, should be converted in special way
 * @returns {void|*}
 */
export const serverCoordinateToLatLng = (serverCoordinate, outdated) => {
  if (typeof serverCoordinate === 'string' && serverCoordinate.indexOf('(') === 0) {
    serverCoordinate = serverLatLonToArray(serverCoordinate)
  }

  if (outdated) {
    let p = new L.Point(serverCoordinate[0] + OUTDATED_LAT_OFFSET, serverCoordinate[1] + OUTDATED_LNG_OFFSET)
    return L.Projection.Mercator.unproject(p)
  }
  return new L.LatLng(serverCoordinate[0], serverCoordinate[1])
}

export const serverLatLonToArray = (serverCoordinate) =>
  serverCoordinate
    .slice(1, serverCoordinate.length - 1)
    .split(',')
    .map((el) => +el)
